import React, { useState } from 'react'
import PopupList from './PopupList'
import AddPopupForm from '../../component/form/popup/AddPopupForm'

export default function AddPopup() {
    const [bool, setBool] = useState(false)
    return (
        <>
         <div className="container-fluid">
                <div className="row">
                    <div className="col-md-12">
                        <div className='layout_head'>
                            <h5>Add Popup</h5>
                            <AddPopupForm  bool={bool} setBool={setBool}/>
                        </div>
                        <div className='layout_head mt-3'>
                            <h5 className='mb-2'> Popup List</h5>
                            <PopupList  bool={bool} setBool={setBool}/>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
